module.exports = __webpack_public_path__ + "static/img/customerservice2.b7b5e4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/customerservice2.png
// module id = 0Dv7
// module chunks = 1